'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _momentTimezone = require('moment-timezone');
var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
var _reactI18next = require('react-i18next');
var _ResponsiveModes = require('../../constants/ResponsiveModes');
require('moment/locale/fr');
require('moment/locale/es');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  Countdown: {
    fontSize: function fontSize(_ref) {
      var countdownFontSize = _ref.otherProperties.countdownFontSize;
      return countdownFontSize + 'rem';
    }
  },
  group: {
    display: 'inline-block',
    textAlign: 'center',
    padding: '0 1rem',
    '&:first-of-type': {
      paddingLeft: 0
    },
    '&:last-of-type': {
      paddingRight: 0
    }
  },
  number: {
    fontSize: function fontSize(_ref2) {
      var responsiveMode = _ref2.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '4em' : responsiveMode === _ResponsiveModes.TABLET ? '3.1em' : '2.3em';
    },
    color: function color(_ref3) {
      var countdownNumberColor = _ref3.otherProperties.countdownNumberColor;
      return countdownNumberColor;
    }
  },
  text: {
    fontSize: function fontSize(_ref4) {
      var responsiveMode = _ref4.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '1em' : responsiveMode === _ResponsiveModes.TABLET ? '0.92em' : '0.84em';
    },
    color: function color(_ref5) {
      var countdownTextColor = _ref5.otherProperties.countdownTextColor;
      return countdownTextColor;
    }
  }
};
var Countdown = function (_Component) {
  _inherits(Countdown, _Component);
  function Countdown(props) {
    _classCallCheck(this, Countdown);
    var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));
    _initialiseProps.call(_this);
    _momentTimezone2.default.locale(props.i18n.language);
    if (_this.props.i18n.language === 'es') _momentTimezone2.default.updateLocale('es', {
      ordinal: '%d'
    });
    var entities = props.entities;
    var _Object$keys$map$ = Object.keys(entities).map(function (k) {
        return entities[k];
      })[0],
      startDate = _Object$keys$map$.startDate,
      endDate = _Object$keys$map$.endDate,
      timezone = _Object$keys$map$.timezone,
      isVirtual = _Object$keys$map$.isVirtual,
      virtualTimezone = _Object$keys$map$.virtualTimezone;
    _this.state = {
      // Shift timezone
      endDate: (0, _momentTimezone2.default)(endDate).tz(isVirtual ? virtualTimezone : timezone),
      startDate: (0, _momentTimezone2.default)(startDate).tz(isVirtual ? virtualTimezone : timezone),
      timeRemaining: 0,
      interval: null
    };
    return _this;
  }
  _createClass(Countdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        interval: setInterval(this.tick, 1000)
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.state.interval);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        t = _props.t;
      var _state$timeRemaining = this.state.timeRemaining,
        days = _state$timeRemaining.days,
        hours = _state$timeRemaining.hours,
        minutes = _state$timeRemaining.minutes,
        seconds = _state$timeRemaining.seconds,
        beforeStart = _state$timeRemaining.beforeStart,
        beforeEnd = _state$timeRemaining.beforeEnd;
      return beforeStart < 0 && beforeEnd > 0 ? _react2.default.createElement('div', {
        className: classes.Countdown,
        style: cssProperties
      }, t('event.date.ongoing_event')) : beforeStart < 0 ? _react2.default.createElement('div', {
        className: classes.Countdown,
        style: cssProperties
      }, t('event.date.past_event')) : _react2.default.createElement('div', {
        className: classes.Countdown,
        style: cssProperties
      }, !!days && this.buildGroup(days, t('date.units.plural.days')), (!!days || !!hours) && this.buildGroup(hours, t('date.units.plural.hours')), (!!days || !!hours || !!minutes) && this.buildGroup(minutes, t('date.units.plural.minutes')), (!!days || !!hours || !!minutes || !!seconds) && this.buildGroup(seconds, t('date.units.plural.seconds')));
    }
  }]);
  return Countdown;
}(_react.Component);
var _initialiseProps = function _initialiseProps() {
  var _this2 = this;
  this.getTimeRemaining = function (state) {
    var startDate = state.startDate,
      endDate = state.endDate;
    var now_date = new Date();
    var now = now_date.getTime();
    return {
      days: startDate.diff(now, 'days'),
      hours: startDate.diff(now, 'hours') % 24,
      minutes: startDate.diff(now, 'minutes') % 60,
      seconds: startDate.diff(now, 'seconds') % 60,
      beforeStart: startDate.diff(now),
      beforeEnd: endDate.diff(now)
    };
  };
  this.tick = function () {
    _this2.setState(function (state) {
      return {
        timeRemaining: _this2.getTimeRemaining(state)
      };
    });
  };
  this.buildGroup = function (number, name) {
    var classes = _this2.props.classes;
    return _react2.default.createElement('div', {
      className: classes.group
    }, _react2.default.createElement('div', {
      className: classes.number
    }, number < 10 ? '0' + number : number), _react2.default.createElement('div', {
      className: classes.text
    }, name));
  };
};
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(Countdown));